
import api from "../../../api/api";


const getRemarkByGrievanceId = (id) =>{
    return new Promise((resolve, reject)=>{
        api.get("/admin/epf/grievance/remark/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}


const save = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/admin/epf/grievance/remark",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}

const saveAndReply = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/admin/epf/grievance/remark-reply",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}



const eprGrievanceRemarkServices = {
    getRemarkByGrievanceId,
    save,
    saveAndReply
}
export default eprGrievanceRemarkServices;